import compose from '../../../../lib/compose';
import connect from '../../../../store/connect';
import withFeatureFlag from '../../../../components/feature-flag/with-feature-flag';
import withRow from '../../../../components/grid/row/with-row';
import VehicleHistorySpecs from '../../../../components/vehicle-history-specs';
import * as actions from '../../../../actions/vip/vis';

const FEATURE_NAME = 'vehicle_history_specs';

const mapStateToProps = ({ [FEATURE_NAME]: vehicleHistorySpecs, id }) => ({ ...vehicleHistorySpecs, itemId: id });

const mapDispatchToProps = dispatch => ({
  fetchModal: itemId => {
    dispatch(actions.fetchVehicleHistoryModal(itemId));
  },
});

const enhance = compose(
  withFeatureFlag(FEATURE_NAME, { pathToComponent: FEATURE_NAME }),
  withRow(FEATURE_NAME),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(VehicleHistorySpecs);
